// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rag_cost_card{
    border-radius: 20px;
    padding: 20px;
    border: 1px solid var(--analytics_grey); 
}`, "",{"version":3,"sources":["webpack://./src/components/Rag/RagCost.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,uCAAuC;AAC3C","sourcesContent":[".rag_cost_card{\n    border-radius: 20px;\n    padding: 20px;\n    border: 1px solid var(--analytics_grey); \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
